


import { ISelectOption } from "../dtos/SelectOptionDto";
enum TotalEarnedWagesNeededIndCodes {
        Item1 = 0,
        Item2 = 1,
        Item3 = 2,
         
}

export class TotalEarnedWagesNeededIndCodes_class {

public static enum = TotalEarnedWagesNeededIndCodes;

  public static readonly enumByText : { [key : string ]: number} = {
    ['Item1']: 0,
    ['Item2']: 1,
    ['Item3']: 2,
    
  };
  public static readonly enumByNumber : { [key : number ]: string} = {
    [0]: "1- Wages are available",
    [1]: "2- Wages not currently available",
    [2]: "3- Wages not available, state should proceed without wages",
    
  };

  public static readonly enumAsSelectOptions:Array<ISelectOption<number>> = [
  {value: 0, text: "1- Wages are available"},
  {value: 1, text: "2- Wages not currently available"},
  {value: 2, text: "3- Wages not available, state should proceed without wages"},
  ]
}

